import { Button } from "@mui/material";
import { ReactElement } from "react";

type Props = {
  text: string;
  hidden?: boolean;
  disabled?: boolean;
  classes?: string;
  icon?: ReactElement;

  onClick(): void;
};

export default function WhiteButton(props: Props): ReactElement {
  const { text, hidden, disabled, classes, icon, onClick } = props;

  return (
    <Button
      hidden={hidden}
      style={{ boxShadow: "0 0 15px #c0c0c057" }}
      className={`bg-white font-bold !rounded-xl !border-0 whitespace-nowrap leading-[50px] ${classes}`}
      disabled={disabled}
      onClick={onClick}
      variant="outlined"
    >
      {icon}
      <span className="mx-2">{text}</span>
    </Button>
  );
}
